import axios from 'axios'

import CommunicationApi from './CommunicationApi'
import OrderApi from './OrderApi'
import ServiceApi from './ServiceApi'
import UserApi from './UserApi'

export default class {
    constructor(baseurl) {
        axios.defaults.baseURL = baseurl
        this.timeoutLogoff = false
        this.listeners = []
        this.communication = new CommunicationApi(this)
        this.order = new OrderApi(this)
        this.service = new ServiceApi(this)
        this.user = new UserApi(this)
        axios.interceptors.response.use((response) => {
            this.setToken(response.headers['x-token'])
            return response
        }, (error) => {
            var errorMessage = ''
            if (error.request.responseType === 'arraybuffer') {
                var enc = new TextDecoder()
                errorMessage = JSON.parse(enc.decode(error.response.data)).error
            } else {
                errorMessage = error.response.data.error
            }
            this.dispatchEvent(new CustomEvent('error', {
                target: this,
                detail: errorMessage
            }))
            return Promise.reject(error)
        })
        var token = window.sessionStorage.getItem('jwt')
        if (token) this.login({ jwt: token })
    }

    addEventListener(type, callback) {
        if (!(type in this.listeners)) {
            this.listeners[type] = []
        }
        this.listeners[type].push(callback)
    }

    removeEventListener(type, callback) {
        if (!(type in this.listeners)) {
            return
        }
        var stack = this.listeners[type]
        for (var i = 0, l = stack.length; i < l; i++) {
            if (stack[i] === callback) {
                stack.splice(i, 1)
                return
            }
        }
    }

    dispatchEvent(event) {
        if (!(event.type in this.listeners)) {
            return true
        }
        var stack = this.listeners[event.type]
        for (var i = 0, l = stack.length; i < l; i++) {
            stack[i].call(this, event)
        }
        return !event.defaultPrevented
    }

    setToken(token) {
        if (!token) return
        if (this.timeoutLogoff) {
            window.clearTimeout(this.timeoutLogoff)
            this.timeoutLogoff = false
        }
        var jwtDecode = require('jwt-decode')
        var jwt = jwtDecode(token)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
        if (jwt.exp) {
            var diff = jwt.exp * 1000 - Date.now()
            if (diff <= 0) diff = 0
            this.timeoutLogoff = window.setTimeout(() => {
                this.logout()
            }, diff)
        }
        window.sessionStorage.setItem('jwt', token)
        return jwt
    }

    login(params) {
        return this.user.login(params).then((response) => {
            var jwt = this.setToken(response.data.jwt)
            this.dispatchEvent(new CustomEvent('login', { target: this, jwt: jwt }))
        })
    }

    logout() {
        if (this.timeoutLogoff) {
            window.clearTimeout(this.timeoutLogoff)
            this.timeoutLogoff = false
        }
        delete axios.defaults.headers.common['Authorization']
        window.sessionStorage.removeItem('jwt')
        this.dispatchEvent(new CustomEvent('logout', { target: this }))
    }

}



// WEBPACK FOOTER //
// ./src/api/AVPublicAPI.js